import Modal from "antd/es/modal";
import React from "react";
import CustomTable from "../common/Table";
import alarmHistoryColumn from "./alarmHistoryColumn";

const AlarmHistoryModal = ({ visible, onClose, data }) => {
    const { historyData, totalAlarmsHistory, hotelListRes: hotels } = data;

    return (
        <Modal
            open={visible}
            title="Alarm history"
            onCancel={onClose}
            width={600}
            footer={null}
        >
            <CustomTable
                columns={alarmHistoryColumn(hotels)}
                tableData={historyData}
                noOfrecords={totalAlarmsHistory}
                rowKey="id"
                isScroll
            />
        </Modal>
    );
};

export default AlarmHistoryModal;
